import React from "react";
import { Container } from "react-bootstrap";
import ResearchBannerimg from "../../assets/img/inner-banner/Research.webp";
import ResearchBannerimgMobile from "../../assets/img/mobile-banner/Research.webp";

const ResearchBanner = () => {
  return (
    <>
      <section>
        <Container fluid className="bannersection position-relative p-0">
          <img
            src={
              window.innerWidth > 568
                ? ResearchBannerimg
                : ResearchBannerimgMobile
            }
            alt="Service banner"
            className="w-100 h-100 object-fit-cover about-banner-img"
          />
          <div className="textoverlay d-flex flex-column justify-content-center align-items-center position-absolute top-0 w-100 h-100 text-center">
            {/* <h1 className="heading">
              The Evolution of Diamond Quality Assessment
            </h1> */}
            <h2>Brilliance is nature's art ; we sign it's name</h2>
          </div>
        </Container>
      </section>
    </>
  );
};

export default ResearchBanner;
